import React from 'react';

const PdpSharedConsultAnExpert = React.lazy(() =>
    import(/* webpackChunkName: "PdpSharedConsultAnExpert" */ './PdpSharedConsultAnExpert')
);

export const PdpSharedConsultAnExpertLazy = props => (
    <React.Suspense fallback="">
        <PdpSharedConsultAnExpert {...props} />
    </React.Suspense>
);
